import { withErrorBoundary } from 'react-error-boundary';
import type { TypeArticleTemplateDetailed, TypeImageDetailed, TypeVideoDetailed } from 'types/autogen/contentful';
import Image from '../Image/Image';
import Video from '../Video';

function TopAssetRenderer(props: NonNullable<TypeArticleTemplateDetailed['fields']['imageRatio169']>) {
    const {
        sys: {
            contentType: {
                sys: { id }
            }
        }
    } = props;

    switch (id) {
        case 'image':
            return (
                <Image
                    {...(props as TypeImageDetailed)}
                    sizes="(min-width: 768px) 720px, (min-width: 1025px) 630px, (min-width: 1441px) 730px, 360px"
                    loading="eager"
                />
            );
        case 'video':
            return <Video {...(props as TypeVideoDetailed)} />;
        default:
            break;
    }
}

export default withErrorBoundary(TopAssetRenderer, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
